import App from './App.vue';
import router from './router';
import { global_init } from '@/glt-global';
import '../assets/theme.css';
import '../assets/theme.light.css';
import '../assets/theme.dark.css';

global_init('home', App as never, router);
